import { FaBriefcase, FaCodeBranch, FaMapMarkerAlt } from "react-icons/fa";

export const HERO_METRICS_DATA = [
  { label: "Years Experience", value: "5+", icon: FaBriefcase, highlight: "Mobile & Full-Stack" },
  { label: "Production Products", value: "13+", icon: FaCodeBranch, highlight: "PayNet, Telkom, Prudential" },
  { label: "Key Impact", value: "20%+", highlight: "Efficiency & Retention Boost" },
  { label: "Current Location", value: "Kuala Lumpur", icon: FaMapMarkerAlt, highlight: "Malaysia & Indonesia" },
];
